import script from "./CorpusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CorpusModal.vue?vue&type=script&setup=true&lang=js"

import "./CorpusModal.vue?vue&type=style&index=0&id=b28a3344&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b28a3344"]])

export default __exports__